<template>
  <div class="page_salary salaryApproval">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px">
            <el-form-item label="归属月" size="small" label-width="70px">
              <el-date-picker v-model="listQuery.AttrMonth" type="month" value-format="yyyy-MM" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="发薪主体" size="small">
              <el-select v-model="listQuery.PayrollCompany" placeholder="" size="small" style="width: 180px;" clearable filterable>
                <el-option v-for="(item, index) in legList" :key="index" :label="item.CompanyName" :value="item.CompanyName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="项目名称" size="small">
              <el-select v-model="listQuery.ProjectName" placeholder="" value-key="Projectid" size="small" style="width: 180px;" clearable filterable>
                <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.StrprojectName"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <!-- <div class="screenInput">
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">{{ showDropScreen == 1 ? '收起' : '更多' }}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div> -->
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen == 1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="98px">
          <div>
            <el-form-item label="发薪公司" size="small" label-width="126px">
              <el-input v-model="listQuery.name" size="small" clearable></el-input>
            </el-form-item>
            <el-form-item label="商务合同主体" size="small">
              <el-input v-model="listQuery.name" size="small" clearable></el-input>
            </el-form-item>
            <el-form-item label="发放途径" size="small">
              <el-select v-model="listQuery.name" placeholder="" clearable filterable>
                <el-option value="银行"></el-option>
                <el-option value="灵活用工"></el-option>
                <el-option value="安心云"></el-option>
                <el-option value="现金"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <!-- <div>
            <el-form-item label="服务部门" size="small">
              <el-input v-model="listQuery.name" size="small" clearable></el-input>
            </el-form-item>
            <el-form-item label="客服" size="small">
              <el-input v-model="listQuery.name" size="small" clearable></el-input>
            </el-form-item>
          </div> -->
        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="resetHandle()">清空</el-button>
        <el-button size="small" type="info" plain @click="showDropScreen = -1">关闭</el-button>
        <el-button v-preventReClick size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs2 flex">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>薪酬</el-breadcrumb-item>
          <el-breadcrumb-item>审核</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="payTips" style="margin-left:542px">注：撤销功能到待发薪流程时需联系相应出纳，前面流程可自行撤销。</div>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" type="card" @tab-click="changeTab">
          <el-tab-pane :label="'算薪（' + num1 + '）'" name="算薪"></el-tab-pane>
          <el-tab-pane :label="'安排资金（' + num10 + '）'" name="安排资金"></el-tab-pane>
          <el-tab-pane :label="'客服主管审批（' + num2 + '）'" name="主管审批" v-if="checkPermission(['salary_manager'], permissionLists)"></el-tab-pane>
          <el-tab-pane :label="'业务审批（' + num3 + '）'" name="业务审批" v-if="checkPermission(['salary_business'], permissionLists)"></el-tab-pane>
          <el-tab-pane :label="'出纳确认（' + num4 + '）'" name="出纳确认" v-if="checkPermission(['salary_cashier'], permissionLists)"></el-tab-pane>
          <el-tab-pane :label="'待发薪（' + num5 + '）'" name="待发薪" v-if="checkPermission(['salary_pendingSalary'], permissionLists)"></el-tab-pane>
          <el-tab-pane :label="'打款中（' + num11 + '）'" name="打款中" v-if="checkPermission(['salary_part'], permissionLists)"></el-tab-pane>
          <el-tab-pane :label="'部分发薪（' + num6 + '）'" name="部分发薪" v-if="checkPermission(['salary_part'], permissionLists)"></el-tab-pane>
          <el-tab-pane :label="'已发薪（' + num7 + '）'" name="已发薪" v-if="checkPermission(['salary_completed'], permissionLists)"></el-tab-pane>
          <el-tab-pane :label="'发薪失败（' + num8 + '）'" name="发薪失败" v-if="checkPermission(['salary_fail'], permissionLists)"></el-tab-pane>
          <el-tab-pane :label="'退回记录（' + num9 + '）'" name="退回记录" v-if="checkPermission(['salary_back'], permissionLists)"></el-tab-pane>
        </el-tabs>
        <div class="ftabBtn flex">
          <el-button type="success" size="small" @click="exportList" :loading="isExpLoading">导出</el-button>
          <!-- <el-button type="warning" size="small">导出人员明细</el-button> -->
        </div>
        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%" :row-class-name="tableRowClassName">
          <el-table-column prop="ProjectName" label="项目名称" width="100" :show-overflow-tooltip="true" align="center" fixed="left">
          </el-table-column>

          <el-table-column prop="AttrMonth" label="归属月" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="ApplicationDate" label="发薪日" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>

          <el-table-column prop="PayType" label="发薪类型" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="PayrollChannel" label="发放途径" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="TotalPayrolls" label="发薪人数" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="TotalResponse" label="应发金额" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="GrandTotal" label="实发金额" width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>
              <div style="color:#ec5656;background:yellow">{{ row.GrandTotal }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="SumIssuedThisMonth" label="待确认应发金额" width="130" :show-overflow-tooltip="true" align="center" v-if="activeName == '出纳确认'">
          </el-table-column>
          <el-table-column prop="GrandTotal" label="待确认实发金额" width="130" :show-overflow-tooltip="true" align="center" v-if="activeName == '出纳确认'">
          </el-table-column>
          <el-table-column prop="CTotalPayrolls" label="待确认人数" width="110" :show-overflow-tooltip="true" align="center" v-if="activeName == '出纳确认'">
          </el-table-column>
          <el-table-column prop="AmountSocialSecurityFund" label="社保公积金" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="PersonalIncomeTax" label="个税" width="80" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="AdvancesEmployees" label="借支" width="80" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="NeedApplyDeposit" label="资金来源" width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>
              {{ !isNull(row.AssociatedClaim) && !isNull(row.ApplyDeposit) ? '客户到款 + 申请垫资' :
            !isNull(row.AssociatedClaim) ? '客户到款' : !isNull(row.ApplyDeposit) ? '申请垫资' : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="PayrollNum" label="发薪编号" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Subject" label="商务合同主体" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="PayrollCompany" label="发薪主体" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="CustomerName" label="客户名称" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="ProcessState" label="流程状态" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="PayScaleRUL" label="导入表附件" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="CustomerOriginalTableRUL" label="客户原表附件" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Remark1" label="申请备注" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Operator" label="申请人" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="CreateTime" label="申请时间" width="150" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>{{ row.CreateTime ? row.CreateTime.replace('T', ' ') : '' }}</template>
          </el-table-column>
          <el-table-column prop="Cashier " label="发薪出纳" width="100" :show-overflow-tooltip="true" align="center" v-if="activeName == '出纳确认'">
          </el-table-column>

          <el-table-column label="操作" align="center" fixed="right" width="200px">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" @click="association(row)">资金来源</el-button>
                <el-button type="text" @click="viewDtl(row)">明细</el-button>
                <el-button type="text" @click="Approve(row)" v-if="activeName == '主管审批' && checkPermission(['salary_examine'], permissionLists)">审批</el-button>
                <el-button type="text" @click="Approve(row)" v-if="activeName == '业务审批' && checkPermission(['salary_businessExamine'], permissionLists)">审批</el-button>
                <el-button type="text" @click="Approve(row)" v-if="activeName == '出纳确认' && checkPermission(['salary_cashierExamine'], permissionLists)">审批</el-button>
                <el-popconfirm title="请确定是否撤销？" @confirm="revoke(row)" style="margin-left: 10px;" v-if="activeName == '主管审批' && checkPermission(['salary_revoke'], permissionLists)">
                  <el-button type="text" slot="reference">撤销</el-button>
                </el-popconfirm>
                <el-popconfirm title="请确定是否撤销？" @confirm="revoke(row)" style="margin-left: 10px;" v-if="activeName == '业务审批' && checkPermission(['salary_businessRevoke'], permissionLists)">
                  <el-button type="text" slot="reference">撤销</el-button>
                </el-popconfirm>
                <el-popconfirm title="请确定是否撤销？" @confirm="revoke(row)" style="margin-left: 10px;" v-if="activeName == '出纳确认' && checkPermission(['salary_cashierRevoke'], permissionLists)">
                  <el-button type="text" slot="reference">撤销</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="block">
          <el-pagination v-if="totalCount > 0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="资金来源" :visible.sync="showAassociation" width="1100px">
      <div class="paymentBox flex">
        <div class="paymentItem">项目名称：
          <el-statistic><template slot="formatter">
              {{ info.ProjectName }}
            </template></el-statistic>
        </div>
        <div class="paymentItem">实发金额 + 个税：￥<el-statistic group-separator="," :precision="2" :value="info.GrandTotal + info.PersonalIncomeTax"></el-statistic>
        </div>
        <!-- <div class="paymentItem">实发金额 + 个税：￥
          <el-statistic group-separator="," :precision="2" :value="info.GrandTotal"></el-statistic>
        </div> -->
        <div class="paymentItem" v-if="multipleSelection.length > 0">勾选汇总金额：￥
          <el-statistic group-separator="," :precision="2" :value="selALLNum"></el-statistic>
        </div>
      </div>
      <el-table :data="PaymentData" class="doc_table" ref="multipleTable" @selection-change="handleSelectionChange" max-height="500px" style="width:100%;margin-bottom: 6px;">
        <el-table-column type="selection" width="60" fixed="left">
        </el-table-column>
        <el-table-column prop="PaymentNum" label="到款编号" width="100" :show-overflow-tooltip="true" align="center" fixed="left">
        </el-table-column>
        <el-table-column prop="TransactionSerialNumber" label="银行卡流水号" width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="BankTransactionDate" label="到款时间" width="155" align="center">
          <template slot-scope={row}>
            {{ row.BankTransactionDate ? row.BankTransactionDate.replace('T', ' ') : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="OppositeOpeningBank" label="对方户名" width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="AccountName" label="我方户名" width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="IncurredAmount" label="到款金额" width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="AmountClaime" label="认领金额" width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="EmainingAvailableCredit" label="可用金额" width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="ProjectName" label="认领项目" width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="Claimant" label="认领人" width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="CreateTime" label="认领时间" width="155" align="center">
          <template slot-scope={row}>
            {{ row.CreateTime ? row.CreateTime.replace('T', ' ') : '' }}
          </template>
        </el-table-column>
      </el-table>
      <div class="block" v-if="expandTotal > 0">
        <el-pagination @current-change="currentChangeExpand" :current-page.sync="claimQuery.pageNum" :page-size="Number(claimQuery.pageSize)" @size-change="handleSizeChangeExpand" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="expandTotal"></el-pagination>
      </div>
      <el-form :inline="true">
        <el-form-item>
          <el-checkbox v-model="payForm.NeedApplyDeposit" true-label="需要申请垫支" false-label="" @change="changeDesignee">需要申请垫支</el-checkbox>
          <el-input v-model="payForm.ApplyDeposit" :disabled="!payForm.NeedApplyDeposit" placeholder="请输入垫资金额" style="width:200px;margin-left: 20px;" size="small"></el-input>
        </el-form-item>
        <el-form-item label="发薪日期" prop="ApplicationDate">
          <el-select v-model="payForm.ApplicationDate" placeholder="" size="small" style="width: 200px;" filterable>
            <el-option v-for="(item, index) in 31" :key="index" :value="item + '日'"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="Subject">
          <el-input v-model="payForm.ApplicationRemarks" type="textarea" :autosize="{ minRows: 3, maxRows: 4 }" style="width:567px" size="small"></el-input>
        </el-form-item>
        <div>
          <el-form-item>
            <div class="payTips">注：安排的金额不得少于 实发金额 + 个税</div>
          </el-form-item>
        </div>
      </el-form>


      <span slot="footer" class="dialog-footer">
        <el-button @click="showAassociation = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmAassociation()">确
          认</el-button>
      </span>
    </el-dialog>

    <div class="salaryApproval_Dialog">
      <el-dialog title="审批" :visible.sync="showApprove" width="900px">
        <el-tabs v-model="activeName2" type="card">
          <el-tab-pane label="审批内容" name="0"></el-tab-pane>
          <el-tab-pane label="工作流" name="1"></el-tab-pane>
          <el-tab-pane label="流程记录" name="2"></el-tab-pane>
        </el-tabs>

        <el-button type="success" size="small" v-if="activeName == '1' || activeName == '2'" @click="printClick('printBox', '')">打印</el-button>
        <div v-if="activeName2 == '0'">
          <div class="descriptions_box" id="printBox" v-if="activeName == '1'">
            <div class="descriptionsTitle" style="width:800px">XXX公司</div>
            <div class="descriptionsTitle" style="color: #666;width:800px">工资发放申请</div>
            <el-descriptions :column="4" border :contentStyle="CS" :label-style="LS" style="width:800px;margin: 0 auto;">

              <el-descriptions-item label="签单部门" :span="2">kooriookami</el-descriptions-item>
              <el-descriptions-item label="业务员" :span="2">XXX</el-descriptions-item>

              <el-descriptions-item label="服务部门" :span="2">XXX</el-descriptions-item>
              <el-descriptions-item label="客服" :contentStyle="{ 'max-width': '120px', 'min-width': '120px', 'text-align': 'center' }">XXX</el-descriptions-item>
              <el-descriptions-item label="申请日期" :contentStyle="{ 'max-width': '120px', 'min-width': '120px', 'text-align': 'center' }">2020-01-07</el-descriptions-item>

              <el-descriptions-item label="所属项目" :span="2">XXX</el-descriptions-item>
              <el-descriptions-item label="客户名称" :contentStyle="{ 'max-width': '120px', 'min-width': '120px', 'text-align': 'center' }">XXX</el-descriptions-item>
              <el-descriptions-item label="薪资月份" :contentStyle="{ 'max-width': '120px', 'min-width': '120px', 'text-align': 'center' }">XXX</el-descriptions-item>

              <el-descriptions-item label="内容" :span="2">XXX</el-descriptions-item>
              <el-descriptions-item label="业务属性" :span="2">XXX</el-descriptions-item>

              <el-descriptions-item label="金额 大写(RMB)" :span="2">壹仟肆佰零玖元伍角</el-descriptions-item>
              <el-descriptions-item label="￥：" :span="2">1459.50</el-descriptions-item>

              <el-descriptions-item label="备注" :span="4">XXX</el-descriptions-item>

              <el-descriptions-item label="申请人" :span="2">XXX</el-descriptions-item>
              <el-descriptions-item label="业务审核" :span="2">XXX</el-descriptions-item>

              <el-descriptions-item label="出纳确认" :span="2">XXX</el-descriptions-item>
              <el-descriptions-item label="出纳" :span="2">XXX</el-descriptions-item>

            </el-descriptions>
          </div>

          <div class="descriptions_box" id="printBox" v-if="activeName == '2'">
            <div class="descriptionsTitle" style="width:600px">XXX公司</div>
            <div class="descriptionsTitle" style="color: #666;width:600px">工资发放申请</div>
            <el-descriptions :column="3" border :contentStyle="CS" :label-style="LS" style="width:600px;margin: 0 auto;">

              <el-descriptions-item label="发薪渠道" :span="3">XXX</el-descriptions-item>

              <el-descriptions-item label="到款银行" :span="2">XXX</el-descriptions-item>
              <el-descriptions-item label="账号" :contentStyle="{ 'max-width': '120px', 'min-width': '120px', 'text-align': 'center' }">XXX</el-descriptions-item>

              <el-descriptions-item label="发薪银行" :span="2">XXX</el-descriptions-item>
              <el-descriptions-item label="账号" :contentStyle="{ 'max-width': '120px', 'min-width': '120px', 'text-align': 'center' }">XXX</el-descriptions-item>

              <el-descriptions-item label="申请日期" :contentStyle="{ 'max-width': '120px', 'min-width': '120px', 'text-align': 'center' }">XXX</el-descriptions-item>
              <el-descriptions-item label="申请人" :contentStyle="{ 'max-width': '120px', 'min-width': '120px', 'text-align': 'center' }">XXX</el-descriptions-item>
              <el-descriptions-item label="申请部门" :contentStyle="{ 'max-width': '120px', 'min-width': '120px', 'text-align': 'center' }">XXX</el-descriptions-item>

              <el-descriptions-item label="是否垫资" :contentStyle="{ 'max-width': '120px', 'min-width': '120px', 'text-align': 'center' }">XXX</el-descriptions-item>
              <el-descriptions-item label="业务类型" :contentStyle="{ 'max-width': '120px', 'min-width': '120px', 'text-align': 'center' }">XXX</el-descriptions-item>
              <el-descriptions-item label="发薪日期" :contentStyle="{ 'max-width': '120px', 'min-width': '120px', 'text-align': 'center' }">XXX</el-descriptions-item>

              <el-descriptions-item label="项目名称" :span="2">XXX</el-descriptions-item>
              <el-descriptions-item label="客户名称" :contentStyle="{ 'max-width': '120px', 'min-width': '120px', 'text-align': 'center' }">XXX</el-descriptions-item>

              <el-descriptions-item label="摘要" :span="2">XXX</el-descriptions-item>
              <el-descriptions-item label="归属月" :contentStyle="{ 'max-width': '120px', 'min-width': '120px', 'text-align': 'center' }">XXX</el-descriptions-item>

              <el-descriptions-item label="金额(大写RMB)" :span="2">XXX</el-descriptions-item>
              <el-descriptions-item label="￥" :contentStyle="{ 'max-width': '120px', 'min-width': '120px', 'text-align': 'center' }">XXX</el-descriptions-item>

              <el-descriptions-item label="团队长" :contentStyle="{ 'max-width': '120px', 'min-width': '120px', 'text-align': 'center' }">XXX</el-descriptions-item>
              <el-descriptions-item label="业绩归属人" :contentStyle="{ 'max-width': '120px', 'min-width': '120px', 'text-align': 'center' }">XXX</el-descriptions-item>
              <el-descriptions-item label="服务中心" :contentStyle="{ 'max-width': '120px', 'min-width': '120px', 'text-align': 'center' }">XXX</el-descriptions-item>

            </el-descriptions>
          </div>

          <div v-if="activeName == '3'">
            <div class="basicInfo flex aic">
              <div class="infoItem">发薪项目: xxxx</div>
              <div class="infoItem">客户名称: xxxx</div>
              <div class="infoItem">申请人: xxxx</div>
              <div class="infoItem">归属月: xxxx</div>
              <div class="infoItem">发放途径: xxxx</div>
              <div class="infoItem">申报月: xxxx</div>
              <div class="infoItem">预支工资金额: xxxx</div>
              <div class="infoItem">实发金额: xxxx</div>
              <div class="infoItem">个税: xxxx</div>
              <div class="infoItem">预支人数: xxxx</div>
            </div>
            <el-table :data="PaymentData" border class="doc_table" style="width:601px;margin-bottom: 20px;">
              <el-table-column prop="name" label="发薪金额" width="200" :show-overflow-tooltip="true" align="center" fixed="left">
              </el-table-column>
              <el-table-column prop="name" label="商务合同主体" width="200" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="name" label="发薪主体" width="200" :show-overflow-tooltip="true" align="center">
              </el-table-column>
            </el-table>
          </div>

          <div class="selectCustomPayment">对应客户到款：<el-button type="text" @click="showPaymentInfo = !showPaymentInfo">{{
            showPaymentInfo ? '收起' : '展开>>' }} </el-button>
          </div>

          <div v-if="showPaymentInfo" class="showPaymentInfo">
            <el-table :data="PaymentData" class="doc_table" style="width:100%;margin-bottom: 20px;">
              <el-table-column prop="name" label="到款编号" width="100" :show-overflow-tooltip="true" align="center" fixed="left">
              </el-table-column>
              <el-table-column prop="name" label="银行卡流水号" width="100" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="name" label="到款时间" width="120" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="name" label="对方户名" width="100" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="name" label="我方户名" width="100" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="name" label="到款金额" width="100" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="name" label="认领金额" width="100" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="name" label="可用金额" width="100" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="name" label="认领项目" width="100" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="name" label="认领人" width="100" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="name" label="认领时间" width="100" :show-overflow-tooltip="true" align="center">
              </el-table-column>
            </el-table>
          </div>

          <div class="selectCustomPayment">垫资申请信息：<el-button type="text" @click="showDZInfo = !showDZInfo">{{ showDZInfo
            ?
            '收起' : '展开>>' }}</el-button>
          </div>
          <el-form v-if="showDZInfo" :inline="true">
            <el-form-item label="垫资金额" label-width="80px">
              <div class="dzItem">5000元</div>
            </el-form-item>
            <el-form-item label="状态" label-width="60px">
              <div class="dzItem">XXX</div>
            </el-form-item>
            <el-form-item label="本客户应收款金额合计" label-width="160px">
              <div class="dzItem">XXX</div>
            </el-form-item>
            <el-form-item label="本客户垫资未核销金额合计" label-width="180px">
              <div class="dzItem">XXXX</div>
            </el-form-item>
          </el-form>

          <div class="remarkInfo" v-if="activeName == '1' || activeName == '2'">
            <el-form :inline="true">
              <el-form-item label="备注" label-width="80px">
                <div>XXX</div>
              </el-form-item>
              <div>
                <el-form-item label="客户原表" label-width="80px">
                  <div style="width:150px">XXX</div>
                </el-form-item>
                <el-form-item label="导入表" label-width="80px">
                  <div>XXX</div>
                </el-form-item>
              </div>
              <el-form-item label="审批备注" label-width="80px">
                <el-input v-model="formData.name" style="width:600px" size="small" type="textarea" maxlength="500" :autosize="{ minRows: 2 }" show-word-limit></el-input>
              </el-form-item>
            </el-form>
          </div>

          <div class="descriptions_box" id="printBox" v-if="activeName == '3'">
            <div class="descriptionsTitle" style="width:600px">XXX公司</div>
            <div class="descriptionsTitle" style="color: #666;width:600px">工资发放申请</div>
            <el-descriptions :column="3" border :contentStyle="CS" :label-style="LS" style="width:600px;margin: 0 auto;">

              <el-descriptions-item label="发薪渠道" :span="3">XXX</el-descriptions-item>

              <el-descriptions-item label="到款银行" :span="2">XXX</el-descriptions-item>
              <el-descriptions-item label="账号" :contentStyle="{ 'max-width': '120px', 'min-width': '120px', 'text-align': 'center' }">XXX</el-descriptions-item>

              <el-descriptions-item label="发薪公司" :span="3">XXX</el-descriptions-item>

              <el-descriptions-item label="申请日期" :contentStyle="{ 'max-width': '120px', 'min-width': '120px', 'text-align': 'center' }">XXX</el-descriptions-item>
              <el-descriptions-item label="申请人" :contentStyle="{ 'max-width': '120px', 'min-width': '120px', 'text-align': 'center' }">XXX</el-descriptions-item>
              <el-descriptions-item label="申请部门" :contentStyle="{ 'max-width': '120px', 'min-width': '120px', 'text-align': 'center' }">XXX</el-descriptions-item>

              <el-descriptions-item label="是否垫资" :contentStyle="{ 'max-width': '120px', 'min-width': '120px', 'text-align': 'center' }">XXX</el-descriptions-item>
              <el-descriptions-item label="业务类型" :contentStyle="{ 'max-width': '120px', 'min-width': '120px', 'text-align': 'center' }">XXX</el-descriptions-item>
              <el-descriptions-item label="发薪日期" :contentStyle="{ 'max-width': '120px', 'min-width': '120px', 'text-align': 'center' }">XXX</el-descriptions-item>

              <el-descriptions-item label="项目名称" :span="2">XXX</el-descriptions-item>
              <el-descriptions-item label="客户名称" :contentStyle="{ 'max-width': '120px', 'min-width': '120px', 'text-align': 'center' }">XXX</el-descriptions-item>

              <el-descriptions-item label="摘要" :span="2">XXX</el-descriptions-item>
              <el-descriptions-item label="归属月" :contentStyle="{ 'max-width': '120px', 'min-width': '120px', 'text-align': 'center' }">XXX</el-descriptions-item>

              <el-descriptions-item label="金额(大写RMB)" :span="2">XXX</el-descriptions-item>
              <el-descriptions-item label="￥" :contentStyle="{ 'max-width': '120px', 'min-width': '120px', 'text-align': 'center' }">XXX</el-descriptions-item>

              <el-descriptions-item label="团队长" :contentStyle="{ 'max-width': '120px', 'min-width': '120px', 'text-align': 'center' }">XXX</el-descriptions-item>
              <el-descriptions-item label="业绩归属人" :contentStyle="{ 'max-width': '120px', 'min-width': '120px', 'text-align': 'center' }">XXX</el-descriptions-item>
              <el-descriptions-item label="服务中心" :contentStyle="{ 'max-width': '120px', 'min-width': '120px', 'text-align': 'center' }">XXX</el-descriptions-item>

            </el-descriptions>
          </div>
        </div>

        <div v-if="activeName2 == '1'">
          <div style="height: 400px;margin-left:30px">
            <el-steps direction="vertical" :active="4" finish-status="success">
              <el-step title="发起流程" description="张三 2023-05-10 09：02:56 备注：XXXXXX"></el-step>
              <el-step title="主管审核" description="张三 2023-05-10 09：02:56 备注：XXXXXX"></el-step>
              <el-step title="业务审批" description="张三 2023-05-10 09：02:56 备注：XXXXXX"></el-step>
              <el-step title="公司审批" description="张三 2023-05-10 09：02:56 备注：XXXXXX"></el-step>
              <el-step title="财务审批" description="张三 2023-05-10 09：02:56 备注：XXXXXX"></el-step>
              <el-step title="待打款" description=" "></el-step>
              <el-step title="部分打款"></el-step>
              <el-step title="已打款"></el-step>
            </el-steps>
          </div>
        </div>

        <div class="timelineBox" v-if="activeName2 == '2'">
          <el-timeline>
            <el-timeline-item timestamp="2018/4/12 " placement="top">
              <el-card>
                <p>时间：2018/4/12 20:46</p>
                <p>记录：出纳确认 通过</p>
                <p>处理人：张三</p>
                <p>备注：XXXXX</p>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp="2018/4/12 " placement="top">
              <el-card>
                <p>时间：2018/4/12 20:46</p>
                <p>记录：出纳确认 通过</p>
                <p>处理人：张三</p>
                <p>备注：XXXXX</p>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp="2018/4/12 " placement="top">
              <el-card>
                <p>时间：2018/4/12 20:46</p>
                <p>记录：出纳确认 通过</p>
                <p>处理人：张三</p>
                <p>备注：XXXXX</p>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="showApprove = false" size="small">取 消</el-button>
          <el-button type="danger" v-preventReClick style="margin-left:10px;" size="small" @click="showApprove = false">退回上一步</el-button>
          <!-- <el-button type="danger" v-preventReClick style="margin-left:10px;" size="small" @click="showApprove = false">不同意</el-button> -->
          <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="showApprove = false">同
            意</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import xz from "../../common";
  import print from 'print-js'
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        listQuery: {
          name: '',
          AttrMonth: '',
          PayrollCompany: '',
          ProjectName: '',
          ProcessState: '算薪',
          pageNum: 1,
          pageSize: 10,
        },
        showDropScreen: -1,
        tableData: [],
        roletype: localStorage.loginRoletype,
        totalCount: 0,
        isExpLoading: false,
        num1: 0,
        num2: 0,
        num3: 0,
        num4: 0,
        num5: 0,
        num6: 0,
        num7: 0,
        num8: 0,
        num9: 0,
        num10: 0,
        num11: 0,
        activeName: '1',
        loading: false,
        activeName2: 0,
        showApprove: false,
        showPaymentInfo: false,
        showDZInfo: false,
        showAassociation: false,
        multipleSelection: [], //到款信息 选择的行
        active: 4,
        formData: {
          name: ''
        },
        PaymentData: [],
        needLoading: false,
        info: {},
        payForm: {
          Id: '',
          AssociatedClaim: '', //认领ID
          NeedApplyDeposit: '', //是否垫资
          ApplyDeposit: '', //垫资金额
          ApplicationRemarks: '', //备注
          ApplicationDate: '', //发薪日期
        },
        CS: {
          'text-align': 'center', //文本居中
          'min-width': '320px', //最小宽度
          'max-width': '320px',
          'word-break': 'break-all'
        },
        LS: {
          'background-color': 'fff',
          'text-align': 'center', //文本居中
          'min-width': '80px', //最小宽度
          'max-width': '80px',
        },
        permissionLists: [],
        legList: [],
        proNameList: [],
        claimQuery: {
          ProjectIdStr: '',
          VestingMonth: '',
          AccountName: '',
          EmainingAvailableCreditMin: 0,
          pageNum: 1,
          pageSize: 200
        },
        expandTotal: 0,
        selALLNum: 0
      }
    },
    created() {
      if (this.$route.query.activeName != undefined && this.$route.query.activeName) {
        this.activeName = this.$route.query.activeName;
        this.listQuery.ProcessState = this.$route.query.activeName;
      }
      this.getButtonPower();
      this.getProList();
      this.getlegalsubjectlist();
      this.getList();
    },
    mounted() {
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible' && this.needLoading) {
          // console.log('visible')
          // 可见时，重新查询。
          // 请求表格数据方法
          this.getList();
          this.needLoading = false;
        } else {
          // console.log('hidden')
        }
      })
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        let that = this
        let butQuery = {
          path: '/calcSalary',
          powerEnName: 'sarary'
        }
        xz.getbtnPowerIdBypage(butQuery).then(res => {
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                that.permissionLists.push(element.Enname);
              }
              // console.log(that.permissionLists)
            } else {
              this.permissionLists = []
            }
          } else {
            this.$message.error('获取按钮权限出错')
            this.permissionLists = []
          }
        })
      },
      isNull(o) {
        // console.log('isnull',o)
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == "NaN" ||
          o == '[{}]'
        );
      },
      //获取法务主体列表
      getlegalsubjectlist() {
        let data = {
          pageNum: '1',
          pageSize: '10000'
        }
        xz.getlegalsubjectlist(data).then(res => {
          if (res.status == 'ok') {
            this.legList = res.data.data;
          } else {
            this.legList = [];
          }
        })
      },
      //获取项目
      getProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.proNameList = res.msg;
          } else {
            this.proNameList = [];
          }
        });
      },
      currentChange(val) {
        this.listQuery.pageNum = Number(val);
        this.getApplicationPayrollList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.getApplicationPayrollList();
      },
      searchHandle() {
        this.listQuery.pageNum = 1;
        this.getList();
      },
      getList() {
        this.getZNum();
        this.getApplicationPayrollList();
        this.getNum2();
        this.getFailNum();
      },
      getFailNum() {
        let data = {
          pageNum: 1,
          pageSize: 0, //临时改动
          Type: '1',
          CardId: '',
          PayrollNum: '',
          BankAccount: '',
          PhoneNum: '',
          EmployeeName: '',
          IsExport: '0'
        }
        xz.getFailedDetaiOrToPaylList(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.num8 = res.data.totalcount;
          } else {
            this.num8 = 0
          }
        })
      },
      //列表
      getApplicationPayrollList() {
        this.loading = true;
        xz.getApplicationPayrollList95(this.listQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data.data;
            this.loading = false;
          } else {
            this.$message.error('系统出错');
            this.totalCount = 0;
            this.tableData = [];
            this.loading = false;
          }
        })
      },
      getNum2() {
        xz.getApplicationPayrollListCount95(this.listQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.num1 = 0;
            this.num2 = 0;
            this.num3 = 0;
            this.num4 = 0;
            this.num5 = 0;
            this.num6 = 0;
            this.num7 = 0;
            // this.num8 = 0;
            this.num9 = 0;
            this.num11 = 0;
            if (res.data.collect1.length > 0) {
              res.data.collect1.forEach(element => {
                if (element.ApproverState == '待发薪') {
                  this.num5 = element.EntNum
                } else if (element.ApproverState == '已发薪') {
                  this.num7 = element.EntNum
                }
                // else if (element.ApproverState == '发薪失败') {
                //   this.num8 = element.EntNum
                // } 
                else if (element.ApproverState == '退回记录') {
                  this.num9 = element.EntNum
                } else if (element.ApproverState == '出纳确认') {
                  this.num4 = element.EntNum
                } else if (element.ApproverState == '打款中') {
                  this.num11 = element.EntNum
                }
              })
            }
            if (res.data.collect.length > 0) {
              res.data.collect.forEach(element => {
                if (element.ApproverState == '算薪') {
                  this.num1 = element.EntNum
                } else if (element.ApproverState == '主管审批') {
                  this.num2 = element.EntNum
                } else if (element.ApproverState == '业务审批') {
                  this.num3 = element.EntNum
                } else if (element.ApproverState == '部分发薪') {
                  this.num6 = element.EntNum
                }
              })
            }
            this.totalCount = res.data.totalcount;
          }
        })
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      changeTab() {
        if (this.activeName == '算薪' || this.activeName == '安排资金') {
          this.$router.push({
            path: '/calcSalary',
            query: {
              activeName: this.activeName
            }
          })
        } else if (this.activeName == '待发薪' || this.activeName == '部分发薪' || this.activeName == '已发薪' || this.activeName == '发薪失败' || this.activeName == '打款中') {
          this.$router.push({
            path: '/payment',
            query: {
              activeName: this.activeName
            }
          })
        } else if (this.activeName == '退回记录') {
          this.$router.push({
            path: '/returnRecord'
          })
        } else {
          this.listQuery.ProcessState = this.activeName;
          this.getList();
        }
      },
      //查看详情
      viewDtl(row) {
        const routerUrl = this.$router.resolve({
          path: '/salaryDtl',
          query: {
            Id: row.Id,
            type: row.type
          }
        });
        window.open(routerUrl.href, "_blank");
      },
      //去审批
      Approve(row) {
        if (this.activeName == '出纳确认') {
          if (this.isNull(row.AssociatedClaim) && this.isNull(row.ApplyDeposit)) {
            this.$message.warning('无资金来源，不能审批。')
          } else {
            this.$router.push({
              path: '/approveDtl',
              query: {
                Id: row.Id,
              }
            })
          }
        } else {
          this.$router.push({
            path: '/approveDtl',
            query: {
              Id: row.Id,
            }
          })
        }

      },
      //撤销
      revoke(row) {
        xz.withdrawClaim(row.Id, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.getList();
            this.$message.success('撤销成功！')
          } else {
            this.getList();
            this.$message.error(res.msg);
          }
        })
      },
      currentChangeExpand(val) {
        this.claimQuery.pageNum = Number(val);
        this.getClaimRecordList(this.info);
      },
      handleSizeChangeExpand(val) {
        this.claimQuery.pageNum = 1;
        this.claimQuery.pageSize = val;
        this.getClaimRecordList(this.info);
      },
      getClaimRecordList(row) {
        this.claimQuery.AccountName = row.Subject;
        xz.getClaimRecordList(this.claimQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.PaymentData = res.data.data;
            this.loading = false;
            this.showAassociation = true;
            this.expandTotal = res.data.totalcount
            //默认勾选
            if (row.AssociatedClaim && res.data.data.length > 0) {
              let ids = row.AssociatedClaim.split(',');
              this.$nextTick(() => {
                ids.forEach(row => {
                  this.$refs.multipleTable.toggleRowSelection(this.PaymentData.find(item => {
                    return row == item.Id;
                  }), true)
                })
              })
            }
          } else {
            this.loading = false;
            this.expandTotal = 0
            this.PaymentData = [];
            this.$message.error('获取到款信息出错')
          }
        })
      },
      //获取到款信息
      association(row) {
        this.info = row;
        this.info.GrandTotal = Number(this.info.GrandTotal);
        this.info.PersonalIncomeTax = Number(this.info.PersonalIncomeTax);
        this.payForm = {
          Id: row.Id,
          AssociatedClaim: '', //认领ID
          NeedApplyDeposit: row.NeedApplyDeposit, //是否垫资
          ApplyDeposit: row.ApplyDeposit, //垫资金额
          ApplicationRemarks: row.ApplicationRemarks, //备注
          ApplicationDate: row.ApplicationDate, //发薪日期
        }
        this.claimQuery.ProjectIdStr = row.ProjectId;
        this.claimQuery.VestingMonth = row.AttrMonth,
          this.loading = true;
        this.getClaimRecordList(row)
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
        let num = 0;
        if (val && val.length > 0) {
          for (let i = 0; i < val.length; i++) {
            if (val[i] != undefined) {
              let element = val[i];
              num += Number(element.EmainingAvailableCredit)
            }
          }
          this.selALLNum = num
        } else {
          this.selALLNum = 0
        }
      },
      isNull(o) {
        // console.log('isnull',o)
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == "NaN" ||
          o == '[{}]' ||
          o == {} ||
          o == 0 ||
          o == '0'
        );
      },
      //确认关联
      confirmAassociation() {
        // if (this.info.TotalResponse > (this.selALLNum + this.payForm.ApplyDeposit)) {
        //   this.$message.warning('安排的金额不得少于应发金额')
        // } else {
        if (this.multipleSelection.length > 0) {
          console.log(this.multipleSelection)
          let arr = []
          this.multipleSelection.forEach(element => {
            if (element != undefined) {
              arr.push(element.Id)
            }
          });
          this.payForm.AssociatedClaim = arr.toString();
        }
        xz.modifyAssociatedPayment(this.payForm, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.getList();
            this.showAassociation = false;
            this.$message.success('关联成功！');
          } else {
            this.getList();
            this.showAassociation = false;
            this.$message.error(res.msg);
          }
        })
        // }
      },
      printClick(id, ignoreIds) {
        const style = '@page {margin:0 10mm};' //打印时去掉眉页眉尾
        printJS({
          printable: id, // 标签元素id
          type: 'html',
          header: '',
          targetStyles: ['*'],
          style,
        });
        //各个配置项
        //printable:要打印的id。
        //type:可以是 html 、pdf、 json 等。
        //properties:是打印json时所需要的数据属性。
        //gridHeaderStyle和gridStyle都是打印json时可选的样式。
        //repeatTableHeader:在打印JSON数据时使用。设置为时false，数据表标题将仅在第一页显示。
        //scanStyles:设置为false时，库将不处理应用于正在打印的html的样式。使用css参数时很有用，此时自己设置的原来想要打印的样式就会失效，在打印预览时可以看到效果
        //targetStyles: [’*’],这样设置继承了页面要打印元素原有的css属性。
        //style:传入自定义样式的字符串，使用在要打印的html页面 也就是纸上的样子。
        //ignoreElements：传入要打印的div中的子元素id，使其不打印。非常好用
      },
      changeDesignee(val) {
        if (val) {
          this.payForm.ApplyDeposit = this.info.TotalResponse
        } else {
          this.payForm.ApplyDeposit = 0
        }
      },
      getZNum() {
        xz.appropriatFundsList(this.listQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.num10 = res.data.totalcount;
          } else {
            this.num10 = 0;
          }
        })
      },
      //导出列表
      exportList() {
        let data = this.listQuery;
        data.IsExport = '1';
        data.pageSize = 100;
        this.isExpLoading = true;
        xz.getApplicationPayrollList95(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            let url = res.data;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/pdf`
            })
            let aLink = document.createElement("a")
            aLink.download = this.activeName + '列表.xls' //这里写保存时的名称
            aLink.href = URL.createObjectURL(blob)
            aLink.click()
            this.isExpLoading = false;
          } else {
            this.isExpLoading = false;
            this.$message.error(res.msg)
          }
        })
      },
      tableRowClassName({
        row,
        rowIndex
      }) {
        if (this.activeName == '出纳确认') {
          if (row.IsAdequacyFunds == '1') {
            return 'warning-row';
          } else {
            return '';
          }
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .descriptions_box {
    margin-bottom: 20px;
  }

  .descriptionsTitle {
    border: 1px solid #EBEEF5;
    border-bottom: none;
    margin: 0 auto;
    padding: 8px 0;
    font-size: 13px;
    font-weight: 600;
    color: #000;
    text-align: center;
  }

  .selectCustomPayment {
    font-weight: 600;
    margin-bottom: 10px;
  }

  .dzItem {
    width: 80px;
  }

  .timelineBox {
    padding-left: 30px;
    width: 500px;
  }

  .basicInfo {
    flex-wrap: wrap;
    margin-bottom: 15px;
  }

  .infoItem {
    color: #000;
    font-size: 13px;
    width: 170px;
    line-height: 32px;
  }

  .paymentBox {
    margin: 10px 0 20px 0;
    padding-left: 30px;
  }

  .paymentItem {
    display: flex;
    white-space: nowrap;
    font-size: 14px;
    margin-right: 30px;
  }

  .payTips {
    color: red;
    padding-left: 20px;
    font-size: 14px;
  }
</style>
<style>
  .page_salary .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_salary .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_salary .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_salary .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_salary .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_salary .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
    /* background: #fff; */
  }

  .salaryApproval_Dialog .el-dialog__body {
    padding-top: 10px;
  }

  .salaryApproval .el-descriptions .is-bordered .el-descriptions-item__cell {
    padding: 8px 5px;
  }

  .salaryApproval .el-descriptions-item__label.is-bordered-label {
    background: #fff;
    color: #000;
    font-weight: 600;
  }

  .salaryApproval .remarkInfo .el-form--inline .el-form-item {
    margin-bottom: 0;
  }

  #tab-算薪 {
    /* background: rgb(255, 199, 206); */
    background: #FFFF00;
    /* color: #fff; */
  }

  #tab-安排资金 {
    /* background: rgb(255, 199, 206); */
    background: #FFFF00;
    /* color: #fff; */
  }

  .salaryApproval .el-breadcrumb {
    min-width: 136px;
  }

  .salaryApproval .el-table .warning-row {
    background: #E6FCC5;
  }
</style>